import { DialogActions } from "@mui/material"
import type { FC } from "react"

import { Button } from "@/components/common/Button"

interface NewRequestStepActionsProps {
  onCancel: () => void
  onContinue: () => void
  continueLabel?: string
  continueDisabled?: boolean
  cancelTestId: string
  continueTestId: string
}

export const NewRequestStepActions: FC<NewRequestStepActionsProps> = ({
  onCancel,
  onContinue,
  continueLabel = "Continue",
  continueDisabled = false,
  cancelTestId,
  continueTestId,
}) => (
  <DialogActions className='justify-between px-8 pb-6 pt-0'>
    <Button appearance='outlined' onClick={onCancel} data-testid={cancelTestId}>
      Cancel
    </Button>
    <Button appearance='contained' disabled={continueDisabled} onClick={onContinue} data-testid={continueTestId}>
      {continueLabel}
    </Button>
  </DialogActions>
)
